import { createApp } from 'vue';
import { router, store } from '@/util';

import App from '@/App.vue';
import { standardMixin } from './standardMixin'
import { appMixin } from './appMixin'

import VueClickAway from "vue3-click-away";
import Multiselect from '@suadelabs/vue3-multiselect'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import Vue3Sanitize from "vue-3-sanitize";
import money from 'v-money3';

const overridenOptions = {
	allowedTags: ['a', 'br'],
	allowedAttributes: {
		'a': ['href', 'target'],
	}
};

// Create App
const app = createApp(App)
	// Include Router
	.use(router)
	// Include Vuex/Store
	.use(store)
	// Mixins
	.mixin(standardMixin)
	.mixin(appMixin)
	// plugins
	.use(VueClickAway)
	.use(Vue3Sanitize, overridenOptions)
	// Components
	.use(money)
	.component('multiselect', Multiselect)
	.component('VueDatePicker', VueDatePicker)

// Scan directory for the Vue components
const files = require.context('@/components/autoload/', true, /\.\/.*\.vue$/)
files.keys().map(key => {
	app.component(key.split('/').pop().split('.')[0], files(key).default);
});

// Finally Mount
app.mount('#app');
